import arduino from "./Arduino.png";
import cpp from "./C++.png";
import css from "./css.png";
import firebase from "./Firebase.png";
import git from "./git.png";
import html from "./html.png";
import java from "./Java.png";
import javascript from "./JavaScript.png";
import jira from "./Jira.png";
import nodejs from "./nodeJS.png";
import python from "./python.png";
import react from "./react.png";
import ros from "./ROS.png";
import vba from "./VBA.png";
import latex from "./latex.png";
import opencv from "./OpenCV.png";
import tensorflow from "./TensorFlow.png";
import pytorch from "./pytorch.png";
import matlab from "./matlab.png";

const logos = {
  arduino,
  cpp,
  ros,
  python,
  opencv,
  tensorflow,
  pytorch,
  css,
  html,
  javascript,
  nodejs,
  react,
  firebase,
  git,
  java,
  vba,
  jira,
  latex,
  matlab,
};

export default logos;
